import Typography from "@material-ui/core/Typography";
import type { LabeledTextProps } from "../types/ui";

export const LabeledText = ({
  label,
  children
}: LabeledTextProps) => {
  return (
    <div>
      <Typography
        variant="subtitle2"
        color="text.secondary"
        sx={{
          fontWeight: 400,
          mt: 1,
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          mb: 1,
        }}
      >
        {children}
      </Typography>
    </div>
  );
};
